import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DashboardRoutingModule} from './dashboard-routing.module';
import {BaseModule} from '../base/base.module';
import {MatSidenav, MatSidenavContainer, MatSidenavContent} from '@angular/material/sidenav';
import {MatNavList} from '@angular/material/list';
import {MatTree, MatTreeNode, MatTreeNodeDef, MatTreeNodePadding, MatTreeNodeToggle} from '@angular/material/tree';
import {MatIconButton} from '@angular/material/button';
import {MatCheckbox} from '@angular/material/checkbox';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatIconModule} from '@angular/material/icon';
import {MatPaginatorModule} from '@angular/material/paginator';
import {DialogModule} from './dialog/dialog.module';
import {AddOrUpdateServicesComponent} from './add-or-update-services/add-or-update-services.component';
import {AdditivesComponent} from './additives/additives.component';
import {AttributeTypesComponent} from './attribute-types/attribute-types.component';
import {AttributesComponent} from './attributes/attributes.component';
import {BusinessesComponent} from './businesses/businesses.component';
import {MenuComponent} from './menu/menu.component';
import {DashboardHeaderComponent} from './dashboard-header/dashboard-header.component';
import {DeliveryMethodsComponent} from './delivery-methods/delivery-methods.component';
import {DomainsComponent} from './domains/domains.component';
import {FactorsComponent} from './factors/factors.component';
import {OrdersComponent} from './orders/orders.component';
import {PaymentMethodsComponent} from './payment-methods/payment-methods.component';
import {RolePermissionsComponent} from './role-permissions/role-permissions.component';
import {RolesComponent} from './roles/roles.component';
import {ServicesComponent} from './services/services.component';
import {TagsComponent} from './tags/tags.component';
import {UsersComponent} from './users/users.component';
import {MatDialogActions, MatDialogContent} from "@angular/material/dialog";
import {SpacesComponent} from './spaces/spaces.component';
import {AddOrUpdateDomainComponent} from './add-or-update-domain/add-or-update-domain.component';
import {OpenFactorsComponent} from './open-factors/open-factors.component';
import {UserDetailComponent} from './user-detail/user-detail.component';
import {HomeComponent} from './home/home.component';
import {PlaceOrderComponent} from './place-order/place-order.component';
import {EnglishNumberOnlyDirective} from "../../util/service/directive/english-number-only.directive";
import {MobileDirective} from '../../util/service/directive/mobile.directive';
import {SpaceStringPipe} from "../../util/pipes/space.string";
import {DragDropModule} from '@angular/cdk/drag-drop';
import {Comments} from './comments/comments';
import {SettingsComponent} from './settings/settings.component';

@NgModule({
  declarations: [
    AddOrUpdateServicesComponent,
    AdditivesComponent,
    AttributeTypesComponent,
    AttributesComponent,
    BusinessesComponent,
    MenuComponent,
    DashboardHeaderComponent,
    DeliveryMethodsComponent,
    DomainsComponent,
    AddOrUpdateDomainComponent,
    FactorsComponent,
    OrdersComponent,
    PaymentMethodsComponent,
    RolePermissionsComponent,
    RolesComponent,
    ServicesComponent,
    TagsComponent,
    UsersComponent,
    SpacesComponent,
    OpenFactorsComponent,
    UserDetailComponent,
    HomeComponent,
    PlaceOrderComponent,
    Comments,
    SettingsComponent
  ],
  exports: [
    DashboardHeaderComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DashboardRoutingModule,
    BaseModule,
    DialogModule,
    MatSidenavContent,
    MatSidenav,
    MatSidenavContainer,
    MatNavList,
    MatTreeNode,
    MatTree,
    MatTreeNodeToggle,
    MatTreeNodePadding,
    MatIconButton,
    MatTreeNodeDef,
    MatCheckbox,
    MatDialogActions,
    MatDialogContent,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatPaginatorModule,
    EnglishNumberOnlyDirective,
    MobileDirective,
    SpaceStringPipe,
    DragDropModule,
    ReactiveFormsModule
  ]
})
export class DashboardModule {
}
